import type { CommendaAiScope } from '@commenda/api/commenda-ai/api';
import { createContext } from 'react';

export interface ICommendaAiWorkspace {
  companyId: number | null;
  /** Firm scope: the conversation spans the affiliate member's clients and `companyId` is null.
   * Unset means the workspace is one company, as everywhere else. */
  scope?: CommendaAiScope;
  /** Label for the header. The affiliate surface supplies the picked client's name, since the
   * client is not in the viewer's own organizations list. */
  workspaceName?: string;
}

export const CommendaAiWorkspaceContext = createContext<
  ICommendaAiWorkspace | undefined
>(undefined);

interface CommendaAiWorkspaceProviderProps {
  workspace: ICommendaAiWorkspace;
  children: React.ReactNode;
}

/** Pins every Commenda AI surface underneath to an explicit workspace instead of the global
 * `useConfig().companyId`. The affiliate console uses this to chat about a picked client without
 * touching the persisted workspace state (whose org-reconciliation can clobber a foreign id).
 * Client-app surfaces mount no provider and keep today's behavior exactly. */
const CommendaAiWorkspaceProvider = ({
  workspace,
  children,
}: CommendaAiWorkspaceProviderProps) => (
  <CommendaAiWorkspaceContext.Provider value={workspace}>
    {children}
  </CommendaAiWorkspaceContext.Provider>
);

export default CommendaAiWorkspaceProvider;
